function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\xCDb\xFA\xF0ir",
  transform: "translate(-402.000000, -359.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "iconmonstr-arrow-25",
  transform: "translate(402.000000, 359.000000)"
}, React.createElement("polygon", {
  id: "Path",
  points: "0 3 3.057 0 15 12 3.057 24 0 21 9 12"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "15px",
    height: "24px",
    viewBox: "0 0 15 24",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/arrow-right-white.d5150b55.svg";
export { SvgComponent as ReactComponent };